import { z } from "zod";
import { CoverageStatus } from "../enums/CoverageStatus";
import { InsuranceType } from "../enums/InsuranceType";
import { dateSchema } from "../utils/DateSchema";
import { nameSchema } from "../utils/NameSchema";
import { requiredStringSchema } from "../utils/RequiredStringSchema";

export const ExcessLiabilityCoverageLimitsSchema = z.object({
  eachOccurrence: z.number(),
  generalAggregate: z.number(),
  products: z.number(),
});

export const ExcessLiabilityCoverageOptionsSchema = z.object({
  umbrellaLiability: z.boolean().optional(),
  excessLiability: z.boolean().optional(),
  retentionLiability: z.boolean().optional(),
  deductibleLiability: z.boolean().optional(),
});

export const ExcessLiabilityPolicySchema = z.object({
  policyNumber: requiredStringSchema().max(50),
  insurer: nameSchema(),
  typeOfInsurance: InsuranceType,
  status: CoverageStatus,
  effectiveDate: dateSchema().optional(),
  expirationDate: dateSchema().optional(),
  limits: ExcessLiabilityCoverageLimitsSchema,
  options: ExcessLiabilityCoverageOptionsSchema,
});

export type ExcessLiabilityPolicy = z.infer<typeof ExcessLiabilityPolicySchema>;

export type ExcessLiabilityCoverageLimits = z.infer<
  typeof ExcessLiabilityCoverageLimitsSchema
>;

export type ExcessLiabilityCoverageOptions = z.infer<
  typeof ExcessLiabilityCoverageOptionsSchema
>;
